export default Object.freeze({
    PENDING  : 'pending',
    PENDING_OVERWRITE  : 'pending_overwrite',
    RUNNING  : 'running',
    SUCCESSED  : 'successed', 
    FAILED  : 'failed', 
})
